import { Component } from '@angular/core';
import { SecondaryPageComponent } from '../../secondary-page/secondary-page.component';

@Component({
  selector: 'app-activities',
  standalone: true,
  imports: [],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.scss'
})
export class ActivitiesComponent extends SecondaryPageComponent {

}
